import React from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';

import { COLORS } from '../../../../constants/styles';
import Button from '../../../Button';
import Icon from '../../../Icon';
import styles from './index.styl';

export function AppointmentFilter({
  formatMessage,
  setAppointmentFiltersOption,
  isFilterToday,
  isFilterByTypeVisit,
}) {
  const todayBtn = formatMessage({ id: 'common.today' });
  const virtualVisitBtn = formatMessage({
    id: 'healthboard.filter.virtualVisit',
  });
  const clearFiltersBtn = formatMessage({
    id: 'healthboard.filter.clearFilters',
  });

  const handleResetAllFilters = () => {
    setAppointmentFiltersOption({
      isFilterToday: false,
      isFilterByTypeVisit: false,
    });
  };

  const handleSetEnabledToday = e => {
    e.stopPropagation();
    setAppointmentFiltersOption({
      isFilterToday: false,
    });
  };

  const handleSetEnabledVirtualVisit = e => {
    e.stopPropagation();
    setAppointmentFiltersOption({
      isFilterByTypeVisit: false,
    });
  };

  return (
    <div className={styles.root}>
      <Button
        className={cn(styles.btn, { [styles.enabledBtn]: isFilterToday })}
        onClick={() =>
          setAppointmentFiltersOption({
            isFilterToday: true,
          })
        }
        border
      >
        <span>{todayBtn}</span>
        {isFilterToday && (
          <Icon
            className={styles.icon}
            style={{ fill: COLORS.white }}
            width={12}
            height={12}
            onClick={handleSetEnabledToday}
            name="close"
          />
        )}
      </Button>
      <Button
        className={cn(styles.btn, styles.btnVirtualVisit, {
          [styles.enabledBtn]: isFilterByTypeVisit,
        })}
        onClick={() =>
          setAppointmentFiltersOption({
            isFilterByTypeVisit: true,
          })
        }
        border
      >
        <span>{virtualVisitBtn}</span>
        {isFilterByTypeVisit && (
          <Icon
            className={styles.icon}
            style={{ fill: COLORS.white }}
            width={12}
            height={12}
            onClick={handleSetEnabledVirtualVisit}
            name="close"
          />
        )}
      </Button>
      {(isFilterToday || isFilterByTypeVisit) && (
        <div
          className={styles.clearBtn}
          onClick={() => handleResetAllFilters()}
        >
          {clearFiltersBtn}
        </div>
      )}
    </div>
  );
}

AppointmentFilter.propTypes = {
  formatMessage: PropTypes.func,
  setAppointmentFiltersOption: PropTypes.func,
  isFilterToday: PropTypes.bool,
  isFilterByTypeVisit: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentFilter/index.jsx